export default "__VITE_ASSET__D05q9bZ$__"